import Bloodhound from 'corejs-typeahead';

$(function () {
    let App = window.App;
    App.chooseYourCity = {};

    let $chooseYourCityModal = $('#chooseYourCityModal'),
        $searchInput = $('#yourCitySearchInput', $chooseYourCityModal),
        $regionInput = $('input[name="region"]', $chooseYourCityModal),
        $regionsList = $('.regions-list', $chooseYourCityModal);

    let $documentBody = $(document.body);

    App.chooseYourCity.setRegion = function ($this) {
        if ($regionsList.hasClass('disabled')) {
            return false;
        }

        $searchInput.val($this.data('value'));
        $regionInput.val($this.data('region-id'));

        saveRegion($this.data('region-id'));
    }

    App.chooseYourCity.setRegionById = function (id, resetPostData) {
        $regionInput.val(id);
        saveRegion(id, resetPostData);
    };

    function saveRegion(city_id, resetPostData = true) {
        $.ajax({
            type: 'POST',
            url: '/cart/region-remember',
            data: {
                city_id
            },
            dataType: 'json',
            beforeSend: function () {
                $regionsList.addClass('disabled');
                $searchInput.prop('disabled', true);
            },
            success: function (response) {
                if (response.hasOwnProperty('city')) {
                    let regionId = response.city.region_id,
                        regionName = response.city.name;

                    if (
                        $documentBody.hasClass('catalog-page') &&
                        response.hasOwnProperty('nearest_delivery_view')
                    ) {
                        const $nearestDeliveryContainer = $('.nearest-delivery-dates-container');
                        const filterButtonView = $nearestDeliveryContainer.find('.applied-filters-btn').html();

                        $nearestDeliveryContainer.replaceWith(response.nearest_delivery_view);
                        $('.nearest-delivery-dates-container').find('.applied-filters-btn')
                            .html(filterButtonView);

                        App.initTooltips();
                    }

                    $('.js-region-name').text(regionName);
                    $('[data-region]').attr('data-region', regionId);
                    $searchInput.val('');

                    if (App.cart) {
                        App.cart.updateDeliveryAndPaymentMethods(response, resetPostData);
                    }

                    if (App.goods) {
                        location.reload();
                    }

                    if (
                        $documentBody.hasClass('delivery-page') &&
                        response.hasOwnProperty('deliveries')
                    ) {
                        $('.methods-list .method').each(function () {
                            let $this = $(this);
                            let delivery = response.deliveries.find((delivery) => delivery.id == $this.attr('data-method-id'));

                            if (delivery) {
                                $this.find('.delivery-time').text(delivery.estimated_time);
                                $this.removeClass('hidden');
                            } else {
                                $this.addClass('hidden');
                            }
                        });
                    }
                }
            },
            complete: function () {
                $regionsList.removeClass('disabled');
                $searchInput.prop('disabled', false);
                App.modal.closeOpenModal();
            }
        });
    }

    $searchInput.typeahead(null, {
        name: 'cities',
        display: 'name',
        limit: 'Infinity',
        source: new Bloodhound({
            remote: {
                url: '/ajax/region-search/?term=%QUERY',
                wildcard: '%QUERY'
            },
            identify: function (obj) {
                return obj.id;
            },
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            datumTokenizer: Bloodhound.tokenizers.whitespace
        })
    }).bind('typeahead:select', function (ev, suggestion) {
        $regionInput.val(suggestion.id);
        saveRegion(suggestion.id);
    });
});
